import { cva, type VariantProps } from 'class-variance-authority';
import styles from '../Chip/styles.module.scss';

export const chipVariants = cva(styles.chip, {
  variants: {
    size: {
      sm: styles.sm,
      md: styles.md,
      lg: styles.lg,
    },
    variant: {
      default: styles.variantDefault,
      secondary: styles.variantSecondary,
    },
    selected: {
      true: styles.selected,
    },
  },
  defaultVariants: {
    size: 'md',
    variant: 'default',
  },
});

export type ChipVariants = VariantProps<typeof chipVariants>;
